import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import './spacer.sass'

@Component
export class Spacer extends Vue {

  render (h: CreateElement) {
    return (
      <hr class='spacer' />
    )
  }

}
